import { makeHook } from "../../utils/makeSingleArgHook";
import getProposalPostTrade, { proposalPostTradeUrl, } from "../requests/getProposalPostTrade";
const useGetProposalPostTrade = makeHook(getProposalPostTrade, (proposalId) => [proposalPostTradeUrl(proposalId)]);
export default useGetProposalPostTrade;
//# sourceMappingURL=useGetProposalPostTrade.js.map